import { render } from "./redirect.vue?vue&type=template&id=3b5e90ca"
import script from "./redirect.vue?vue&type=script&lang=ts"
export * from "./redirect.vue?vue&type=script&lang=ts"
script.render = render

export default script